import React from "react";
import AppSelect from "../AppSelect/AppSelect";
import {getFiltersForType} from "../../../Utils/FilterOperationHelper";

/**
 * Propose les filtres disponibles pour le type d'opération sélectionné.
 * @param {object} props
 * @param {string} [props.type]
 * @param {string} [props.id]
 * @param {string} [props.value]
 * @param {(id: string, value: string) => void} [props.onValueChanged]
 * @param {boolean} [props.isDarkStyle]
 * @param {boolean} [props.isHashMapOption]
 * @param {object} props.I18n
 * @param {(key: string) => string} props.I18n.get
 */
export default function FilterOperationTypeSelector(props) {
    const {
        type = "",
        id = "filter",
        value,
        onValueChanged,
        isDarkStyle = false,
        isHashMapOption = false,
        I18n
    } = props;

    const options = React.useMemo(() => {
        return getFiltersForType(type);
    }, [type]);

    const defaultValue = React.useMemo(() => {
        if (value && options.includes(value)) {
            return value;
        }

        return options.length > 0 ? options[0] : "";
    }, [value, options]);

    if (options.length === 0) {
        return null;
    }

    return (
        <AppSelect
            id={id}
            label={I18n.get("Select filter")}
            allowEmpty={false}
            defaultValue={defaultValue}
            onValueChanged={onValueChanged}
            isDarkStyle={isDarkStyle}
            isHashMapOption={isHashMapOption}
            options={options}
            I18n={I18n}
        />
    );
}
